@if (required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        class='weaveInput weaveCurrency'
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut()"
        (focusout)="onFocusOut()"
        (keyup)="onFocusOut()"
        (keydown.enter)='$event.target.blur()'
        [(ngModel)]='data'
        [placeholder]="placeholder"
        currencyMask
        nonZeroRequired
        [options]="{ prefix: '$', thousands: ',', decimal: '.' }"
        required
        #ctrl="ngModel"
      >
      @if(ctrl.invalid && ctrl.touched) {
        <mat-error>
          {{label || "This field"}} is required
        </mat-error>
      }
      @if (showError && ( data === '' || data == "0" ) && required) {
        <div
          class="weaveFormField_error">
          {{label || "This field"}} cannot be empty
        </div>
      }
    </mat-form-field>
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }
  </div>
}
@if (!required) {
  <div class="weaveFormField">
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        class='weaveInput weaveCurrency'
        [options]="{ prefix: '$', thousands: ',', decimal: '.' }"
        currencyMask
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut()"
        (focusout)="onFocusOut()"
        (keyup)="onFocusOut()"
        (keydown.enter)='$event.target.blur()'
        [(ngModel)]='data'
        [placeholder]="placeholder"
      >
    </mat-form-field>
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }
  </div>
}
